module.exports = __webpack_public_path__ + "static/media/maintainance.6f82fba7.png";